@if (tags.length) {
  <div class="palantir-table-labels">
    <palantir-tag [prefix]="tags[0].prefix" [suffix]="tags[0].suffix" [color]="tags[0].color">{{
      tags[0].tag
    }}</palantir-tag>
    @if (tags.length > 1) {
      <palantir-tag [prefix]="tags[1].prefix" [suffix]="tags[1].suffix" [color]="tags[1].color"
        >{{ tags[1].tag }}
      </palantir-tag>
    }

    @if (tags.length > 2) {
      <div class="palantir-table-labels__more" [cdkMenuTriggerFor]="menu">
        <palantir-text type="primary" size="2xs">+{{ tags.length - 2 }}</palantir-text>
      </div>
    }
  </div>
}

<ng-template #menu>
  <palantir-content class="palantir-menu palantir-table-labels__menu" cdkMenu layout="no-padding">
    <div class="palantir-table-labels__menu--header">
      <palantir-text type="subtitle"> {{ labelTranslate }} </palantir-text>
    </div>

    <div class="palantir-table-labels__menu__content">
      @for (tag of tags; track trackByFn($index, tag)) {
        <div class="palantir-table-labels__menu__content--item">
          <palantir-tag [color]="tag.color">
            {{ tag.tag }}
          </palantir-tag>
        </div>
      }
    </div>
  </palantir-content>
</ng-template>

@if (!tags.length) {
  <palantir-text italic="true" type="description" size="xs">
    {{ emptyText }}
  </palantir-text>
}
